import { Component, OnInit } from '@angular/core';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-page-access-denied',
    templateUrl: './page-access-denied.component.html',
    styleUrls: ['./page-access-denied.component.css'],
    providers: [Title],
    standalone: false
})
export class PageAccessDeniedComponent implements OnInit {
  public readonly Constant = Constant;
  constructor(private title: Title) {
    this.title.setTitle(Constant.pageTitleError + Constant.pageTitleCommon);
  }

  ngOnInit() {}
}
